import * as React from 'react'

export const SvgBin = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={25} height={24} aria-hidden={true} {...props}>
    <path d="M9.5 3h6v2h6v2h-1.128l-2 14H6.637l-2-14H3.5V5h6V3zm8.851 4H6.657l1.714 12h8.266l1.714-12zm-5.097 10V9h-1.5v8h1.5zm3.1-7.87l-.697 7.97-1.494-.13L14.86 9l1.494.13zm-5.508 7.84L10.149 9l-1.495.13.697 7.97 1.495-.13z" />
  </svg>
)
export default SvgBin
